import styled from 'styled-components';

export const DivMain = styled.div`
    width: 100vw;
    height: 100vh;
    background: rgb(0, 185, 187);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    flex-direction: column;
`;
export const SpanLoader = styled.span`
    font-size: 35px;
    margin: 0 0 50px 0;
    color:#2c1d1d;
    user-select:none;
`
